export const STAFF_SALARY_REQUEST = "STAFF_SALARY_REQUEST";
export const STAFF_SALARY_SUCCESS = "STAFF_SALARY_SUCCESS";
export const STAFF_SALARY_FAIL = "STAFF_SALARY_FAIL";
export const STAFF_SALARY_RESET = "STAFF_SALARY_RESET";

export const STAFF_REGISTER_REQUEST = "STAFF_REGISTER_REQUEST";
export const STAFF_REGISTER_SUCCESS = "STAFF_REGISTER_SUCCESS";
export const STAFF_REGISTER_FAIL = "STAFF_REGISTER_FAIL";
export const STAFF_REGISTER_RESET = "STAFF_REGISTER_RESET";

export const STAFF_DELETE_REQUEST = "STAFF_DELETE_REQUEST";
export const STAFF_DELETE_SUCCESS = "STAFF_DELETE_SUCCESS";
export const STAFF_DELETE_FAIL = "STAFF_DELETE_FAIL";
export const STAFF_DELETE_RESET = "STAFF_DELETE_RESET";

export const STAFF_LIST_REQUEST = "STAFF_LIST_REQUEST";
export const STAFF_LIST_SUCCESS = "STAFF_LIST_SUCCESS";
export const STAFF_LIST_FAIL = "STAFF_LIST_FAIL";
export const STAFF_LIST_RESET = "STAFF_LIST_RESET";

export const STAFF_SEARCH_REQUEST = "STAFF_SEARCH_REQUEST";
export const STAFF_SEARCH_SUCCESS = "STAFF_SEARCH_SUCCESS";
export const STAFF_SEARCH_FAIL = "STAFF_SEARCH_FAIL";

export const STAFF_UPDATE_REQUEST = "STAFF_UPDATE_REQUEST";
export const STAFF_UPDATE_SUCCESS = "STAFF_UPDATE_SUCCESS";
export const STAFF_UPDATE_FAIL = "STAFF_UPDATE_FAIL";

export const STAFF_ATTENDANCE_REQUEST = "STAFF_ATTENDANCE_REQUEST";
export const STAFF_ATTENDANCE_SUCCESS = "STAFF_ATTENDANCE_SUCCESS";
export const STAFF_ATTENDANCE_FAIL = "STAFF_ATTENDANCE_FAIL";
export const STAFF_ATTENDANCE_RESET = "STAFF_ATTENDANCE_RESET";
